/*=========================================================================================
  File Name: moduleecommerce.js
  Description: ecommerce Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
	namespaced: true,
    state: {
        products: [],
        totalQuantity: 0,
        totalAmount: 0,
        totalUsdAmount: 0,
        form: false,
    },
    mutations: {
        RELOAD_DATA(state, item) { /* work */
            state.totalQuantity = item.totalQuantity;
            state.totalAmount = item.totalAmount;
            state.totalUsdAmount = item.totalUsdAmount;
            state.products = item.products;
            state.form = item.form;
        },
        REMOVE_ITEM_FROM_BASKET(state, item) {
            const index = state.products.findIndex(i => i.id == item.id);
            if (index >= 0) {
                state.products.splice(index, 1)
            }
        },
    },
    actions: {
        reloadData({ commit }, data) { /* work */
            commit('RELOAD_DATA', data)
        },
        removeItemFromBasket({ commit }, item) { /* work */
            commit('REMOVE_ITEM_FROM_BASKET', item)
        },
    },
}
